import { useCallback, useEffect, useState } from "react";
import "./Checkout.css";

export default function CheckoutPopup({ pkg, addon, onClose, onPayment }) {
    const [basicAmount, setBasicAmount] = useState(0);
    const [taxAmount, setTaxAmount] = useState(0);
    const [finalAmount, setFinalAmount] = useState(0);
    const [quantity, setQuantity] = useState(1);

    useEffect(() => {
        if (pkg) {
            let basic = getBasicAmount(pkg.discountPrice, 18, pkg.isInclusiveTax);
            let tax = calculateTax(pkg.discountPrice, 18, pkg.isInclusiveTax);
            let final = pkg.isInclusiveTax ? pkg.discountPrice : basic + tax;
            setBasicAmount(basic);
            setTaxAmount(tax);
            setFinalAmount(final);
        }
    }, [pkg, addon])

    useEffect(() => {
        if (addon) {
            let price = addon.originalOfferPrice * quantity;

            let basic = getBasicAmount(price, addon.taxPercentage, addon.isInclusiveOfTax);
            let tax = calculateTax(price, addon.taxPercentage, addon.isInclusiveOfTax);
            let final = addon.isInclusiveOfTax ? price : basic + tax;
            setBasicAmount(basic);
            setTaxAmount(tax);
            setFinalAmount(final);
        }
    }, [quantity])

    const roundTo = (num, precision) => {
        const factor = Math.pow(10, precision)
        return Math.round(num * factor) / factor
    }

    const calculateTax = (amount, taxpercentage, isInclusiveOfTax) => {
        if (isInclusiveOfTax) {
            return amount - amount * (100 / (100 + taxpercentage));

        }
        else {
            return amount * (taxpercentage / 100);
        }
    }

    const getBasicAmount = (amount, taxpercentage, isInclusiveOfTax) => {
        if (isInclusiveOfTax) {
            return amount * (100 / (100 + taxpercentage));
        }

        return amount;
    }

    const handleQtyChange = (qty) => {
        if (qty >= 1 && qty <= 100) {
            setQuantity(qty);
        }
    };

    const handleQtyClick = (action) => {
        if (action === "add") {
            let value = quantity >= 100 ? 100 : quantity + 1;
            setQuantity(value);
        } else {
            let value = quantity <= 1 ? 1 : quantity - 1;
            setQuantity(value);
        }
    };

    return (
        <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
            <div className="modal-dialog order-summary modal-lg modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header p-4">
                        <h5 className="modal-title">Checkout</h5>
                        <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body p-4" >
                        <div className="gx-5 row">
                            <div className="position-relative col-12">
                                <div>
                                    <div className="order-breakdown">
                                        {pkg && (
                                            <>
                                                <div className="plan-name">
                                                    <img height="50" src="/images/card-advance-sale.png" />
                                                    <div className="d-flex flex-column">
                                                        <div className="plan-title">{pkg.title}</div>
                                                        <small>(Billed Every Year)</small>
                                                    </div>
                                                </div>

                                                <div className="plan-breakdown">
                                                    <div className=" mt-2 text-mute flex-grow-1">
                                                        <div className="d-flex justify-content-between ">
                                                            <strong>{pkg.title}</strong>
                                                            <div>₹ {roundTo(basicAmount, 2)}</div>
                                                        </div>
                                                        <div className="mt-2 d-flex flex-column gap-2">
                                                            <div className="ms-2">
                                                                {pkg.invitations}
                                                            </div>
                                                        </div>
                                                        <div className="d-flex justify-content-between mt-3">
                                                            <small>GST (18%)</small>
                                                            <small>₹ {roundTo(taxAmount, 2)}</small>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="divider mt-2">
                                                        </div>
                                                        <div className="d-flex justify-content-between ">
                                                            <div>Total Amount</div>
                                                            <div><strong>₹ {roundTo(finalAmount, 2)}</strong></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {addon && (
                                            <>
                                                <div className="plan-breakdown">
                                                    <div className=" mt-2 text-mute flex-grow-1">
                                                        <div className="d-flex justify-content-between ">
                                                            <strong>{addon.name}</strong>
                                                            <div className="qty-input" style={{ width: "fit-content" }}>
                                                                <button
                                                                    className="qty-count qty-count--minus"
                                                                    onClick={() => handleQtyClick("subtract")}
                                                                    disabled={quantity <= 1}
                                                                >
                                                                    -
                                                                </button>
                                                                <input
                                                                    type="number"
                                                                    className="product-qty"
                                                                    value={quantity}
                                                                    onChange={(e) => handleQtyChange(parseInt(e.target.value))}
                                                                    min="1"
                                                                    max="100"
                                                                />
                                                                <button
                                                                    className="qty-count qty-count--add"
                                                                    onClick={() => handleQtyClick("add")}
                                                                    disabled={quantity >= 100}
                                                                >
                                                                    +
                                                                </button>
                                                            </div>
                                                            <div>₹ {roundTo(basicAmount, 2)}</div>
                                                        </div>
                                                        <div className="d-flex justify-content-between mt-3">
                                                            <small>GST ({addon.taxPercentage}%)</small>
                                                            <small>₹ {roundTo(taxAmount, 2)}</small>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="divider mt-2">
                                                        </div>
                                                        <div className="d-flex justify-content-between ">
                                                            <div>Total Amount</div>
                                                            <div><strong>₹ {roundTo(finalAmount, 2)}</strong></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {pkg && (
                        <div className="modal-footer">
                            <button className="btn btn-primary px-4" onClick={(e) => onPayment(pkg)}>Proceed To Pay</button>
                        </div>
                    )}
                    {addon && (
                        <div className="modal-footer">
                            <button className="btn btn-primary px-4" onClick={(e) => onPayment(addon, quantity)}>Proceed To Pay</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
} 